import { Github, Linkedin, Twitter, ArrowUpRight } from "lucide-react";

const YEAR = new Date().getFullYear();

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="relative border-t border-hairline pt-20 md:pt-28 pb-10 bg-[color:var(--bg)]"
    >
      <div className="mx-auto max-w-[1440px] px-6 md:px-10">
        <div className="grid md:grid-cols-12 gap-10 pb-16 md:pb-24">
          <div className="md:col-span-6">
            <div className="mono-label">[end] Beacon IT Solution</div>
            <h3 className="mt-6 font-display text-4xl md:text-7xl leading-[0.95] tracking-[-0.03em]">
              Ship real software.
              <br />
              <span className="text-[color:var(--accent)]">Not slideware.</span>
            </h3>
            <a
              href="#contact"
              data-testid="footer-cta"
              className="mt-10 inline-flex items-center gap-3 border border-white/20 hover:border-[color:var(--accent)] hover:bg-[color:var(--accent)] px-6 py-4 text-[14px] transition-colors"
            >
              Start a project <ArrowUpRight size={16} />
            </a>
          </div>

          <div className="md:col-span-2">
            <div className="mono-label mb-4">Navigate</div>
            <ul className="space-y-3 text-[14px]">
              {[
                ["Services", "/#services"],
                ["Technology", "/#technology"],
                ["Portfolio", "/#portfolio"],
                ["Process", "/#process"],
                ["About", "/#about"],
                ["Careers", "/careers"],
                ["Contact", "/#contact"],
              ].map(([l, h]) => (
                <li key={l}>
                  <a href={h} className="text-white/70 hover:text-[color:var(--accent)]">{l}</a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-2">
            <div className="mono-label mb-4">Studio</div>
            <address className="not-italic text-white/70 text-[14px] leading-relaxed">
              Beacon IT Solution
              <br />
              Pune, Maharashtra
              <br />
              India
            </address>
          </div>

          <div className="md:col-span-2">
            <div className="mono-label mb-4">Social</div>
            <ul className="flex gap-3 flex-wrap">
              {[
                { Icon: Linkedin, label: "LinkedIn", href: "https://linkedin.com" },
                { Icon: Twitter, label: "Twitter/X", href: "https://twitter.com" },
                { Icon: Github, label: "GitHub", href: "https://github.com" },
              ].map(({ Icon, label, href }) => (
                <a
                  key={label}
                  href={href}
                  aria-label={label}
                  data-testid={`social-${label.toLowerCase().split("/")[0]}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 grid place-items-center border border-hairline hover:border-[color:var(--accent)] hover:text-[color:var(--accent)] transition-colors"
                >
                  <Icon size={16} />
                </a>
              ))}
            </ul>
          </div>
        </div>

        <div className="border-t border-hairline pt-6 flex flex-col md:flex-row md:items-center md:justify-between gap-3 mono-label !text-white/50">
          <span>© {YEAR} Beacon IT Solution · beaconitdev.com</span>
          <span>Pune, India — Engineering since 2012</span>
        </div>
      </div>
    </footer>
  );
}
